<div class="modal-header">
    <h5 class="modal-title" id="modal-title">Environment Mapper Details</h5>
</div>
<div class="modal-body" id="modal-body"  style="padding-top: 5px;">
    <div class="text-right font-weight-bold">
        <a class="clickable" [routerLink]="['/user/environment-management']" target="_blank">Add / View Environment</a>
    </div>
    <h4 *ngIf="testsuiteDetails.environmentMap">{{testsuiteDetails.environmentMap.name}}</h4>
    <h4 *ngIf="mastersuiteDetails.environmentMap">{{mastersuiteDetails.environmentMap.name}}</h4>
    <div *ngFor="let env of environments">
        <h6>{{env.name}}</h6>
        <table class="table table-bordered table-sm">
            <thead>
                <tr class="active">
                    <th width="25%">Name</th>
                    <th>Domain / Sub domain</th>
                    <th width="20%">Project</th>
                </tr>
            </thead>
            <tr *ngFor="let subEnv of env.environments">
                <td>{{subEnv.name}}</td>
                <td>{{subEnv.subDomain}}</td>
                <td>{{subEnv.project.name}}</td>
            </tr>
        </table>
    </div>
</div>